export default __webpack_public_path__ + "static/media/CEDIA-Familia-colonos.3311b4ac.jpg";